type Step = 'cart' | 'checkout' | 'confirm';

const STEPS: { id: Step; label: string; icon: string }[] = [
  { id: 'cart', label: 'السلة', icon: 'ri-shopping-bag-3-line' },
  { id: 'checkout', label: 'إتمام الطلب', icon: 'ri-file-list-3-line' },
];

const STEP_ORDER: Step[] = ['cart', 'checkout', 'confirm'];

interface Props {
  current: Step;
}

export default function StepIndicator({ current }: Props) {
  const currentIndex = STEP_ORDER.indexOf(current);

  return (
    <div className="flex items-center justify-center gap-0 mb-10" dir="rtl">
      {STEPS.map((step, i) => {
        const stepIndex = STEP_ORDER.indexOf(step.id);
        const isDone = currentIndex > stepIndex;
        const isActive = current === step.id;

        return (
          <div key={step.id} className="flex items-center">
            <div className="flex flex-col items-center gap-2">
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-full border-2 transition-all duration-300 font-bold text-sm ${
                  isDone
                    ? 'bg-green-500 border-green-500 text-white'
                    : isActive
                    ? 'bg-[#C9A961] border-[#C9A961] text-white scale-110'
                    : 'bg-white border-gray-200 text-gray-400'
                }`}
              >
                {isDone ? (
                  <i className="ri-check-line text-lg" />
                ) : (
                  <i className={`${step.icon} text-base`} />
                )}
              </div>
              <span
                className={`text-xs font-bold whitespace-nowrap transition-colors duration-300 ${
                  isActive ? 'text-[#C9A961]' : isDone ? 'text-green-500' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>

            {i < STEPS.length - 1 && (
              <div
                className={`w-32 h-0.5 mb-5 mx-2 transition-colors duration-500 ${
                  currentIndex > i ? 'bg-green-400' : 'bg-gray-200'
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
